import http from './http';
import {
    CodelistCatalog,
    CodelistCatalogCreate,
    CodelistCatalogUpdate,
    CodelistLookupEntry,
    CodelistRefreshResult,
    MetricsPreviewResponse,
    Page,
    SyncTarget,
    SyncTargetCreate,
    SyncTargetUpdate
} from '../types';

export async function listSyncTargets(page: number, size: number, name?: string, source?: string, enabled?: boolean): Promise<Page<SyncTarget>> {
    const params: any = { page, size };
    if (name && name.trim().length > 0) params.name = name.trim();
    if (source && source.length > 0) params.source = source;
    if (enabled !== undefined && enabled !== null) params.enabled = enabled;
    const res = await http.get<Page<SyncTarget>>('/sync-targets', { params });
    return res.data;
}

export async function createSyncTarget(payload: SyncTargetCreate) {
    const res = await http.post<SyncTarget>('/sync-targets', payload);
    return res.data;
}

export async function uploadManualSyncTarget(file: File) {
    const form = new FormData();
    form.append('file', file);
    const res = await http.post<Array<SyncTarget>>('/sync-targets/manual/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return res.data;
}

export async function updateSyncTargetEnabled(id: string, enabled: boolean) {
    const res = await http.patch<SyncTarget>(`/sync-targets/${id}`, { enabled });
    return res.data;
}

export async function updateSyncTarget(id: string, payload: SyncTargetUpdate) {
    const res = await http.patch<SyncTarget>(`/sync-targets/${id}/details`, payload);
    return res.data;
}

export async function previewSyncTarget(id: string, page: number, size: number) {
    const res = await http.get<MetricsPreviewResponse>(`/sync-targets/${id}/preview`, { params: { page, size } });
    return res.data;
}

export async function deleteSyncTarget(id: string) {
    await http.delete(`/sync-targets/${id}`);
}

export async function listCodelists(page: number, size: number, search?: string, enabled?: boolean): Promise<Page<CodelistCatalog>> {
    const params: { page: number; size: number; search?: string; enabled?: boolean } = { page, size };
    if (search?.trim()) params.search = search.trim();
    if (enabled !== undefined) params.enabled = enabled;
    const res = await http.get<Page<CodelistCatalog>>('/codelists', { params });
    return res.data;
}

export async function createCodelist(payload: CodelistCatalogCreate): Promise<CodelistCatalog> {
    const res = await http.post<CodelistCatalog>('/codelists', payload);
    return res.data;
}

export async function updateCodelist(id: string, payload: CodelistCatalogUpdate): Promise<CodelistCatalog> {
    const res = await http.patch<CodelistCatalog>(`/codelists/${id}`, payload);
    return res.data;
}

export async function refreshCodelist(id: string): Promise<CodelistRefreshResult> {
    const res = await http.post<CodelistRefreshResult>(`/codelists/${id}/refresh`);
    return res.data;
}

export async function listCodelistEntries(id: string, page: number, size: number, search?: string): Promise<Page<CodelistLookupEntry>> {
    const params: { page: number; size: number; search?: string } = { page, size };
    if (search?.trim()) params.search = search.trim();
    const res = await http.get<Page<CodelistLookupEntry>>(`/codelists/${id}/entries`, { params });
    return res.data;
}